/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assistant.rpc.ChatRpc
 */
import * as References from './ChatRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assistant.rpc.ChatRpc#chat
 */
export const CHAT_QUERY_FIELD_NAME = 'com_hubspot_academy_assistant_rpc_ChatRpc_chat';
export const CHAT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: CHAT_QUERY_FIELD_NAME,
  args: ['message', 'threadId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.chatRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assistant.rpc.ChatRpc#getEncryptedConfig
 */
export const GET_ENCRYPTED_CONFIG_QUERY_FIELD_NAME = 'com_hubspot_academy_assistant_rpc_ChatRpc_getEncryptedConfig';
export const GET_ENCRYPTED_CONFIG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ENCRYPTED_CONFIG_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getEncryptedConfigRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assistant.rpc.ChatRpc#getEncryptedConfigWithModifiedSystemPrompt
 */
export const GET_ENCRYPTED_CONFIG_WITH_MODIFIED_SYSTEM_PROMPT_QUERY_FIELD_NAME = 'com_hubspot_academy_assistant_rpc_ChatRpc_getEncryptedConfigWithModifiedSystemPrompt';
export const GET_ENCRYPTED_CONFIG_WITH_MODIFIED_SYSTEM_PROMPT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ENCRYPTED_CONFIG_WITH_MODIFIED_SYSTEM_PROMPT_QUERY_FIELD_NAME,
  args: ['systemPrompt'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getEncryptedConfigWithModifiedSystemPromptRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assistant.rpc.ChatRpc#getSystemPrompt
 */
export const GET_SYSTEM_PROMPT_QUERY_FIELD_NAME = 'com_hubspot_academy_assistant_rpc_ChatRpc_getSystemPrompt';
export const GET_SYSTEM_PROMPT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SYSTEM_PROMPT_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getSystemPromptRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assistant.rpc.ChatRpc#retrieveAuthToken
 */
export const RETRIEVE_AUTH_TOKEN_QUERY_FIELD_NAME = 'com_hubspot_academy_assistant_rpc_ChatRpc_retrieveAuthToken';
export const RETRIEVE_AUTH_TOKEN_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RETRIEVE_AUTH_TOKEN_QUERY_FIELD_NAME,
  args: ['conversationId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.retrieveAuthTokenRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});